// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 1022) return "static/chunks/1022-9cbd835031c5a560.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 1074 ? "fd88a8a7" : chunkId) + "." + {"1074":"2fc8b54d2a032efa","2741":"653c787f2490dc24","9151":"6a9b7a07e881df89","9651":"bddd959a7c85efc2"}[chunkId] + ".js";
};